// extracted by mini-css-extract-plugin
export default {"Dashboard":"AdminDashboard_Dashboard__AOENX","ringChart":"AdminDashboard_ringChart__DM83g"};